import { isCursorLearnMoreOpenAtom } from "frontend/app-header/left-header/atoms/left-header-atoms";
import {
  AutoDetectIcon,
  CursorsHideIcon,
  CursorsIcon,
  MouseIcon,
  PreferencesIcon,
  TrackpadIcon,
} from "frontend/app-header/left-header/menu/icons";
import { MenuLabel } from "frontend/ui-components/dropdown-menu/label/label";
import { useCanvasSettings } from "frontend/hooks/use-canvas-settings";
import { Menu, MenuItem } from "frontend/ui-components/dropdown-menu/dropdown-menu";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { syncServiceAtom } from "state-atoms";
import { navModeAtom } from "state-atoms/nav-atoms";

export const PreferencesMenu = () => {
  const syncService = useAtomValue(syncServiceAtom);
  const { areSettingsLoaded, getSetting, updateSetting } = useCanvasSettings(syncService);
  const showCursors = getSetting("showCursors") ?? false;
  const [navMode, setNavMode] = useAtom(navModeAtom);
  const setIsCursorLearnMoreOpen = useSetAtom(isCursorLearnMoreOpenAtom);

  const handleCursorsChange = (option: boolean) => {
    updateSetting("showCursors", option);
  };

  if (!areSettingsLoaded) return null;

  return (
    <Menu label={<MenuLabel icon={<PreferencesIcon />} label="Preferences" />}>
      <Menu label={<MenuLabel icon={<CursorsIcon />} label="Cursors" />}>
        <MenuItem
          label={<MenuLabel icon={<CursorsIcon />} label="Show cursors" />}
          selected={showCursors}
          onClick={() => handleCursorsChange(true)}
        />
        <MenuItem
          label={<MenuLabel icon={<CursorsHideIcon />} label="Hide cursors" />}
          selected={!showCursors}
          onClick={() => handleCursorsChange(false)}
        />
      </Menu>
      <Menu label={<MenuLabel icon={<MouseIcon />} label="Mouse or trackpad" />}>
        <MenuItem
          label={<MenuLabel icon={<AutoDetectIcon />} label="Auto-detect" />}
          selected={navMode === "auto-detect"}
          onClick={() => setNavMode("auto-detect")}
        />
        <MenuItem
          label={<MenuLabel icon={<MouseIcon />} label="Mouse" />}
          selected={navMode === "mouse"}
          onClick={() => setNavMode("mouse")}
        />
        <MenuItem
          label={<MenuLabel icon={<TrackpadIcon />} label="Trackpad" />}
          selected={navMode === "trackpad"}
          onClick={() => setNavMode("trackpad")}
        />
        <MenuItem label={<MenuLabel label="Learn more" />} onClick={() => setIsCursorLearnMoreOpen(true)} />
      </Menu>
    </Menu>
  );
};
